import { useLocation, useModel, useNavigate } from '@umijs/max';
import { Button, Divider, Tag, Typography } from 'antd';
import dayjs from 'dayjs';
import { useState } from 'react';

import styles from './index.less';

const { Text, Paragraph } = Typography;

export function ReportCard({
  data,
}: {
  data: API.RobotMqttResponse<API.EVENT.Event>;
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const { closeChatbot } = useModel('chatbot');
  const { previewReport } = useModel('report');
  const [loading, setLoading] = useState(0);
  console.log('[Report Card]', data);
  const event = data.payload;

  // 判断是否在当前报告页面
  const isCurrentReportPage =
    location.pathname === `/reports/detail/${event.reportId}`;

  const onShowDetail = (event: API.EVENT.Event, isExport: boolean = false) => {
    // closeChatbot();
    setLoading(isExport ? 2 : 1);
    setTimeout(() => {
      setLoading(0);
    }, 3000);
    if (isCurrentReportPage) {
      previewReport(isExport);
    } else {
      navigate(
        `/reports/detail/${event.reportId}${isExport ? '?export=2' : '?export=1'}`,
      );
    }
  };

  return (
    <div className={styles.cardContainer} style={{ width: 300 }}>
      <div className={styles.header}>
        <Text type="secondary">
          生成时间：{dayjs.unix(data.timestamp).format('YYYY-MM-DD HH:mm:ss')}
        </Text>
      </div>
      <div className={styles.title}>
        <Tag bordered={false} color="blue">
          任务报告
        </Tag>
        <Text>{event.taskName}</Text>
      </div>
      <div className={styles.content}>
        <Paragraph>{event.alertContent}</Paragraph>
      </div>
      <div className={styles.footer} style={{ width: '100%' }}>
        <Button
          loading={loading === 1}
          block
          type="link"
          onClick={() => onShowDetail(event)}
        >
          查看
        </Button>
        <Divider type="vertical" />
        <Button
          loading={loading === 2}
          block
          type="link"
          onClick={() => onShowDetail(event, true)}
        >
          导出
        </Button>
      </div>
    </div>
  );
}
